import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-contacts-list',
  templateUrl: './contacts-list.component.html',
  styleUrls: ['./contacts-list.component.css']
})
export class ContactsListComponent {
  url: string       = 'invoice/contacts';

  data: Array<any>  = [];
  isLoading: boolean = false;

  constructor(
    private dataService: DataService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.isLoading = true;
    this.dataService.getData(`${this.url}/list`).subscribe(response => {
      console.log('response', response)
      this.data = response.data;
      this.isLoading = false;
    });
  }

  deleteData(id: string): void {
    if (!confirm('You want to delete the record?')) {
      return;
    }

    this.dataService.deleteData(`${this.url}/delete/${id}`).subscribe(response => {

      if (response.rst) {
        //this.messageService.add(response.msg, 'info');
      } else {
        this.messageService.add(response.msg, 'secondary');
      }

      this.getData();
    });
  }

}
